import React, {useEffect, useState} from "react";
import './../Purchase.scss';
import {useHistory} from "react-router";
import PurchaseStatus from "../PurchaseStatus";
import Strings from "../../../../config/Strings";
import GlobalConstants from "../../../../config/GlobalConstants";
import {authCheck} from "../../../../util/authCheck";
import {TigerButton} from "../../../../global/tiger-button/TigerButton";
import {Form} from "react-bootstrap";
import {ConfirmationModal} from "../../../../global/ConfirmationModal";

export default function TicketPurchaseAddress() {

    const [purchaseData, setPurchaseData] = useState(JSON.parse(sessionStorage.getItem('ls.purchase')));
    const [contact, setContact] = useState((purchaseData != null && purchaseData.contact != null ) ? purchaseData.contact : {country: "DE"});
    const [email] = useState(JSON.parse(sessionStorage.getItem('email')));
    const [showLoginHint, setShowLoginHint] = useState(false);
    const [formError, setFormError] = useState({
        firstName: null,
        lastName: null,
        street: null,
        houseNumber: null,
        zip: null,
        city: null,
        country: null
    })

    const history = useHistory();

    document.title = Strings.PURCHASE_TICKET_BROWSER_TAB;

    useEffect(() => {
        if (purchaseData == null) {
            history.push("/" + GlobalConstants.APP_PATH + "purchase");
        }
        if (!authCheck()) {
            purchaseData.maxStep = 1;
            sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));
            history.push("/" + GlobalConstants.APP_PATH + "purchase/ticket/authenticate");
        }
    }, [history, purchaseData]);

    const submitContactData = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }
        contact.email = email != null ? email.email : null;
        purchaseData.contact = contact;
        purchaseData.maxStep = 3;

        setPurchaseData(purchaseData);
        sessionStorage.setItem('ls.purchase', JSON.stringify(purchaseData));

        history.push("/" + GlobalConstants.APP_PATH + "purchase/ticket/confirmation");
    }

    const validateForm = () => {
        let formIsValid = true;
        if (contact.firstName == null || contact.firstName === "") {
            formIsValid = false;
            setFormError({
                ...formError,
                firstName: Strings.PURCHASE_CONTACT_ERROR
            });
        }
        if (contact.lastName == null || contact.lastName === "") {
            formIsValid = false;
            setFormError({
                ...formError,
                lastName: Strings.PURCHASE_CONTACT_ERROR
            });
        }
        if (contact.street == null || contact.street === "") {
            formIsValid = false;
            setFormError({
                ...formError,
                street: Strings.PURCHASE_CONTACT_ERROR
            });
        }
        if (contact.zip == null || contact.zip === "") {
            formIsValid = false;
            setFormError({
                ...formError,
                zip: Strings.PURCHASE_CONTACT_ERROR
            });
        }
        if (contact.country == null || contact.country === "") {
            formIsValid = false;
            setFormError({
                ...formError,
                country: Strings.PURCHASE_CONTACT_ERROR
            });
        }
        return formIsValid;
    }

    const updateContact = (field, value) => {
        setContact({
            ...contact,
            [field]: value
        });
        setFormError({
            ...formError,
            [field]: null
        });
    }

    const onChangeStep = (step) => {
        switch (step) {
            case 1:
                setShowLoginHint(true);
                return;
            case 2:
                history.push("/" + GlobalConstants.APP_PATH + "purchase/ticket/payment");
                return;
            case 3:
                if (purchaseData.maxStep > 2) {
                    history.push("/" + GlobalConstants.APP_PATH + "purchase/ticket/confirmation");
                }
                return;
            case 4:
                if (purchaseData.maxStep > 3) {
                    history.push("/" + GlobalConstants.APP_PATH + "purchase/ticket/confirmation");
                }
                return;
            default:
                return;
        }
    }

    return (
        <div className="purchase-container">
            <PurchaseStatus step={2} maxStep={purchaseData != null ? purchaseData.maxStep : 1}
                            onChangeStep={(step) => onChangeStep(step)}
            />
            <div className="purchase-info" dangerouslySetInnerHTML={{__html: Strings.PURCHASE_CONTACT_INFO}}/>
            <div className="purchase-form-container">
                <div className="purchase-form">
                    <Form className="text-left" onSubmit={(e) => submitContactData(e)}>
                        {/* FIRST NAME */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketNo">
                            <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_FIRSTNAME}</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={ formError.firstName != null}
                                value={contact.firstName}
                                onChange={e => updateContact('firstName', e.target.value)}
                                plaintext={Strings.PURCHASE_CONTACT_FIRSTNAME}
                            />

                            <Form.Control.Feedback type="invalid">
                                {formError.firstName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* LAST NAME */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketNo">
                            <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_LASTNAME}</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={ formError.lastName != null}
                                value={contact.lastName}
                                onChange={e => updateContact('lastName', e.target.value)}
                                plaintext={Strings.PURCHASE_CONTACT_LASTNAME}
                            />

                            <Form.Control.Feedback type="invalid">
                                {formError.lastName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* STREET */}
                        <div>
                            <Form.Group className="mb-3" style={{display: "inline-block", width: "75%", marginRight: "5%"}} controlId="ticketRedemptionTicketNo">
                                <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_STREET}</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    isInvalid={ formError.street != null}
                                    value={contact.street}
                                    onChange={e => updateContact('street', e.target.value)}
                                    plaintext={Strings.PURCHASE_CONTACT_STREET}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {formError.street}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" style={{display: "inline-block", width: "20%"}} controlId="ticketRedemptionTicketNo">
                                <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_HOUSE_NO}</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    isInvalid={ formError.houseNumber != null}
                                    value={contact.houseNumber}
                                    onChange={e => updateContact('houseNumber', e.target.value)}
                                    plaintext={Strings.PURCHASE_CONTACT_HOUSE_NO}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {formError.houseNumber}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>

                        {/* ZIP */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketNo">
                            <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_POSTAL_CODE}</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={ formError.zip != null}
                                value={contact.zip}
                                onChange={e => updateContact('zip', e.target.value)}
                                plaintext={Strings.PURCHASE_CONTACT_POSTAL_CODE}
                            />

                            <Form.Control.Feedback type="invalid">
                                {formError.zip}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* CITY */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketNo">
                            <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_CITY}</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={ formError.city != null}
                                value={contact.city}
                                onChange={e => updateContact('city', e.target.value)}
                                plaintext={Strings.PURCHASE_CONTACT_CITY}
                            />

                            <Form.Control.Feedback type="invalid">
                                {formError.city}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* COUNTRY */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketNo">
                            <Form.Label className="auth-label">{Strings.PURCHASE_CONTACT_COUNTRY}</Form.Label>
                            <Form.Control
                                style={{height: "40px", fontSize: "16pt"}}
                                as="select"
                                required
                                isInvalid={ formError.country != null}
                                value={contact.country}
                                onChange={e => updateContact('country', e.target.value)}
                                plaintext={Strings.PURCHASE_CONTACT_FIRSTNAME}
                            >
                                <option value="DE">{Strings.PURCHASE_COUNTRY_DE}</option>
                                <option value="CH">{Strings.PURCHASE_COUNTRY_CH}</option>
                                <option value="AT">{Strings.PURCHASE_COUNTRY_AT}</option>
                            </Form.Control>

                            <Form.Control.Feedback type="invalid">
                                {formError.country}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <br />

                        <TigerButton className="w-100" variant="red">
                            {Strings.PURCHASE_PROCEED_BUTTON}
                        </TigerButton>
                    </Form>
                </div>
                <ConfirmationModal
                    title={Strings.PURCHASE_REAUTHENTICATE_TITLE}
                    text={Strings.PURCHASE_REAUTHENTICATE_HINT}
                    actionButtonLabel={Strings.PURCHASE_REAUTHENTICATE_BUTTON}
                    actionButtonVariant="danger"
                    onActionPress={() => {
                        localStorage.removeItem("ls.token");
                        sessionStorage.removeItem("ls.purchase");
                        history.push("/" + GlobalConstants.APP_PATH + "purchase/" + purchaseData.planVariantId)
                    }}
                    show={showLoginHint}
                    onHide={() => setShowLoginHint(false)}
                />
            </div>

        </div>
    )
}